import React, { ReactNode, useState } from 'react';
import { FormattedDate, useIntl } from 'react-intl';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { ButtonLink } from '@daedalus/atlas/ButtonLink';
import { Grid } from '@daedalus/atlas/helpers/Grid';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { dateStringToMiddayDate } from '@daedalus/core/src/utils/date';
import { SplitBookingInstructionModal } from '../SplitBookingInstructionModal';
interface BookingTransitionMessageProps {
  midDate: string;
  checkIn: string;
  checkOut: string;
  onButtonClick?: () => void;
  title: ReactNode;
  message: ReactNode;
  hasCustomStyle?: boolean;
}
const _exp = /*#__PURE__*/() => ButtonLink;
const StyledButtonLink = /*#__PURE__*/styled(_exp())({
  name: "StyledButtonLink",
  class: "sdwzfgo",
  propsAsIs: true
});
const _exp4 = /*#__PURE__*/() => Grid;
const Container = /*#__PURE__*/styled(_exp4())({
  name: "Container",
  class: "c17i0zm1",
  propsAsIs: true
});
export const BookingTransitionMessage = ({
  midDate,
  checkIn,
  checkOut,
  onButtonClick,
  title,
  message,
  hasCustomStyle = false
}: BookingTransitionMessageProps) => {
  const [isInstructionPopUpOpen, setIsInstructionPopUpOpen] = useState(false);
  const intl = useIntl();
  const handleOnClick = () => {
    setIsInstructionPopUpOpen(true);
    onButtonClick?.();
  };
  return <Container className={cx(hasCustomStyle && 'hasCustomStyle')}>
      <Text variant={hasCustomStyle ? 'labelM' : 'labelS'} dataId="splitBooking.midStayText">
        <FormattedMessageWrapper id="splitBooking.midStayText" defaultMessage="Room switch required {midDay}, {midDate}." values={{
        midDate: intl.formatDate(midDate, {
          day: 'numeric',
          month: 'short',
          timeZone: 'UTC'
        }),
        midDay: <FormattedDate value={dateStringToMiddayDate(midDate)} weekday="short" />
      }} />
      </Text>

      <StyledButtonLink variant="default" size="lg" onClick={handleOnClick} isCompact>
        <Text variant={hasCustomStyle ? 'labelM' : 'labelS'} tag="span" dataId="splitBooking.howItWorksButton">
          <FormattedMessageWrapper id="why" defaultMessage="Why?" />
        </Text>
      </StyledButtonLink>
      {isInstructionPopUpOpen && <SplitBookingInstructionModal isOpen={isInstructionPopUpOpen} title={title} message={message} checkInDate={checkIn} checkOutDate={checkOut} transitionDate={midDate} closeModal={() => setIsInstructionPopUpOpen(false)} />}
    </Container>;
};

require("./SplitBookingTransitionMessage.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SplitBookingTransitionMessage.tsx");